<template>
    <div>
        <button @click="exec" class="btn" :class="buttonClass">{{label}}</button>
        <div class="text-left">
            <!-- update modal -->
            <b-modal v-if="!complete" v-model="actionModal" centered hide-footer :title="title">
                <div class="text-left">
                    <div class="form-group" :class="{ 'form-group--error': $v.newAmount.$error }">
                        <label for="amount">{{'Amount' | trans}}</label>
                        <input v-model="formattedAmount" class="form-control" type="text" id="amount"
                               :class="status($v.newAmount)">
                        <ul class="invalid-feedback list-unstyled" v-if="$v.newAmount.$error">
                            <li v-if="!$v.newAmount.required">
                                {{'This field is required' | trans}}
                            </li>
                        </ul>
                        <form-errors :field-name="'amount'" />
                    </div>
                    <button @click="showPin" class="btn btn-dark-blue">{{label | trans}}</button>
                </div>
            </b-modal>
            <!-- pin modal -->
            <b-modal v-model="pinModal" lazy centered hide-footer hide-header no-close-on-backdrop no-close-on-esc>
                <pin-group v-model="pin" :v="$v.pin" :lock="compensationLoading" :hide-pin-button="hidePinButton"
                           @pinDialogSubmit="submit" @pinDialogCancel="pinModal=false" :cancel-button="`true`">
                    <template slot="header">
                        <p>{{'You are performing a compensation on' | trans}} {{employee}}<br>
                            {{'for' | trans}} {{amount}}</p>
                        <p>{{'Confirm with your PIN' | trans}}.</p>
                    </template>
                </pin-group>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate';
    import { mapGetters, mapActions } from 'vuex';
    const { required, minLength, maxLength, integer } = require('vuelidate/lib/validators');

    export default {
        name: "compensation",
        mixins: [validationMixin],
        props: ['recordId', 'label', 'action', 'refNum', 'amount', 'orgId', 'employee'],
        data() {
            return {
                actionModal: false,
                pinModal: false,
                hidePinButton: false,
                isSendPending: false,
                pin: '',
                newAmount: '',
            }
        },
        computed: {
            ...mapGetters('Finance', ['compensationLoading']),
            complete: function() {
                return this.action == 1;
            },
            title: function() {
                return this.refNum + ", " + this.amount;
            },
            formattedAmount: {
                get: function() {
                    return this.newAmount;
                },
                set: function(newValue) {
                    this.newAmount = this.formatAmount(newValue.replace(/\s/g, ""));
                }
            },
            buttonClass: function() {
                return {
                    'btn-success': this.label.toLowerCase() == 'complete',
                    'btn-warning': this.label.toLowerCase() != 'complete'
                }
            }
        },
        methods: {
            ...mapActions('Finance', ['updateCompensation', 'completeCompensation']),
            submit() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let params = {
                        recordId: this.recordId,
                        orgId: this.orgId,
                        pin: this.pin
                    };
                    let action;
                    if (this.complete) {
                        action = this.completeCompensation(params);
                    } else {
                        params.amount = this.parsePrice(this.newAmount);
                        action = this.updateCompensation(params);
                    }
                    action.then(response => {
                        this.EventBus.$emit('event-success', 'Success');
                        this.hidePinButton = true;
                        setTimeout(() => {
                            if (this.complete) {
                                window.location.href = window.cauriWalletDashboard
                            } else {
                                window.location.reload();
                            }
                        }, this.beforeRedirectTimeOut);
                    }).catch(() => {
                        this.pinModal = false;
                    });
                }
            },
            exec() {
                if(this.complete) {
                    this.showPin();
                } else {
                    this.actionModal = true;
                }
            },
            showPin() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.$v.$reset();
                    this.pinModal = true;
                }
            },
        },
        validations() {
            let v = {
                pin: {},
                newAmount: {}
            };
            if(!this.complete) {
                v.newAmount = {required};
            }
            if(this.pinModal) {
                v.pin = {
                    required,
                    minLength: minLength(4),
                    maxLength: maxLength(4),
                    integer
                };
            }
            return v;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/compensation.vue